export * as avatarStyleConfigs from './style-configs';
export { Avatar } from './avatar';
